import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'お問い合わせ｜さかなの木';
  }, []);

  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      question: '予約は必要ですか?',
      answer: 'ご予約なしでもご利用いただけますが、お席の確保のため事前のご予約をおすすめしております。お電話またはLINEにてお気軽にご予約ください。',
    },
    {
      question: '個室はありますか?',
      answer: '申し訳ございませんが、個室のご用意はございません。カウンター席とテーブル席をご用意しております。',
    },
    {
      question: '駐車場はありますか?',
      answer: '専用駐車場はございませんが、近隣にコインパーキングがございます。鵜の木駅から徒歩30秒の好立地ですので、電車でのご来店が便利です。',
    },
    {
      question: 'テイクアウトの注文方法は?',
      answer: 'テイクアウト弁当は前日までのご予約制となっております。お電話またはLINEにてご注文ください。',
    },
    {
      question: 'クレジットカードは使えますか?',
      answer: '各種クレジットカード、電子マネー、QRコード決済に対応しております。詳しくはスタッフまでお尋ねください。',
    },
    {
      question: '貸切はできますか?',
      answer: '貸切も承っております。人数や日時によって対応可能ですので、お電話にてご相談ください。',
    },
  ];

  return (
    <div className="min-h-screen" style={{ 
      backgroundImage: 'url(https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/5d31dba04b972db5b208ebc63780821f.png)',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center'
    }}>
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/488814045f8b783dec919162c77b149d.webp"
            alt="さかなの木 お問い合わせ"
          />
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">CONTACT</h2>
              <p className="text-lg md:text-xl mt-4 text-white">ご予約・お問い合わせ</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>お問い合わせ｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Contact Methods */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#3A3D3F' }}>
              ご予約・お問い合わせ方法
            </h2>
            <p className="text-gray-600">お電話またはLINEにてお気軽にお問い合わせください</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Phone */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-all hover:-translate-y-2">
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-6">
                <i className="ri-phone-line text-4xl text-primary"></i>
              </div>
              <h3 className="text-2xl font-bold text-center mb-4" style={{ color: '#3A3D3F' }}>電話予約</h3>
              <p className="text-3xl font-bold text-primary text-center mb-4">
                <a href="tel:03-6715-0369" className="hover:text-primary/80 transition-colors cursor-pointer">
                  03-6715-0369
                </a>
              </p>
              <div className="text-center text-sm text-gray-600 mb-6">
                <p className="mb-2"><strong>ランチ</strong></p>
                <p className="mb-4">月曜日〜土曜日 11:30-14:00</p>
                <p className="mb-2"><strong>ディナー</strong></p>
                <p className="mb-1">月曜日〜木曜日 17:00-22:00</p>
                <p className="mb-1">金曜日・土曜日 17:00-23:00</p>
                <p className="mt-4 text-red-600"><strong>定休日: 日曜日・不定休</strong></p>
              </div>
              <a
                href="tel:03-6715-0369"
                className="block w-full px-6 py-3 bg-primary text-white rounded-full text-center font-medium hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer"
              >
                電話をかける
              </a>
            </div>

            {/* LINE */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-all hover:-translate-y-2">
              <div className="w-20 h-20 flex items-center justify-center bg-[#06C755]/10 rounded-full mx-auto mb-6">
                <i className="ri-line-fill text-4xl text-[#06C755]"></i>
              </div>
              <h3 className="text-2xl font-bold text-center mb-4" style={{ color: '#3A3D3F' }}>LINE予約</h3>
              <p className="text-lg text-gray-600 text-center mb-6">
                公式LINEで簡単予約
              </p>
              <div className="text-center text-sm text-gray-600 mb-6">
                <p className="mb-4">LINEなら24時間いつでもご予約・お問い合わせが可能です。</p>
                <ul className="text-left space-y-2 max-w-xs mx-auto">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-[#06C755] mt-0.5"></i>
                    <span>営業時間外でも予約可能</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-[#06C755] mt-0.5"></i>
                    <span>最新情報をお届け</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-[#06C755] mt-0.5"></i>
                    <span>お得な情報も配信</span>
                  </li>
                </ul>
              </div>
              <a
                href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-6 py-3 bg-[#06C755] text-white rounded-full text-center font-medium hover:bg-[#06C755]/90 transition-all whitespace-nowrap cursor-pointer"
              >
                LINEで予約する
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Business Hours */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: '#3A3D3F' }}>
              営業時間・定休日
            </h2>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <table className="w-full">
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="px-6 py-4 font-bold bg-beige" style={{ color: '#3A3D3F' }}>ランチ</td>
                    <td className="px-6 py-4" style={{ color: '#3A3D3F' }}>月曜日〜土曜日</td>
                    <td className="px-6 py-4 text-primary font-bold">11:30 - 14:00</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="px-6 py-4 font-bold bg-beige" style={{ color: '#3A3D3F' }} rowSpan={2}>ディナー</td>
                    <td className="px-6 py-4" style={{ color: '#3A3D3F' }}>月曜日〜木曜日</td>
                    <td className="px-6 py-4 text-primary font-bold">17:00 - 22:00</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="px-6 py-4" style={{ color: '#3A3D3F' }}>金曜日・土曜日</td>
                    <td className="px-6 py-4 text-primary font-bold">17:00 - 23:00</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 font-bold bg-beige" style={{ color: '#3A3D3F' }}>定休日</td>
                    <td className="px-6 py-4 text-red-600 font-bold" colSpan={2}>日曜日・不定休</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-center text-sm text-gray-600 mt-6">
              ※ラストオーダーは、料理が閉店1時間前、ドリンクが閉店30分前となります。<br />
              ※不定休の詳細は、Instagramでご確認ください。
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-primary text-sm font-bold tracking-wider">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>
              よくあるご質問
            </h2>
          </div>
          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-6 py-4 flex items-center justify-between hover:bg-opacity-90 transition-colors cursor-pointer"
                  style={{ backgroundColor: '#d4edeb', color: '#3A3D3F' }}
                >
                  <span className="font-medium text-left">{faq.question}</span>
                  <i
                    className={`text-2xl transition-transform ${
                      openFaq === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 py-4 bg-gray-50 leading-relaxed" style={{ color: '#3A3D3F' }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Store Info */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#3A3D3F' }}>店舗情報</h2>
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="space-y-6 text-left">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                    <i className="ri-store-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>店名</p>
                    <p style={{ color: '#3A3D3F' }}>さかなの木</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>住所</p>
                    <p style={{ color: '#3A3D3F' }}>
                      〒146-0091<br />
                      東京都大田区鵜の木2-5-5<br />
                      イーグル鵜の木原田ビル1階G号
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>電話番号</p>
                    <p style={{ color: '#3A3D3F' }}>
                      <a href="tel:03-6715-0369" className="hover:text-primary transition-colors cursor-pointer">
                        03-6715-0369
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>メールアドレス</p>
                    <p style={{ color: '#3A3D3F' }}>
                      <a href="mailto:sakananoki0808@gmail.com" className="hover:text-primary transition-colors cursor-pointer">
                        sakananoki0808@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
